import { createSelector } from 'reselect';

const getHasLoaded = createSelector(
  (state) => state.paintingCollections.hasLoaded,
  (hasLoaded) => hasLoaded
);
const getCurrencyData = createSelector(
  (state) => state.paintingCollections.data.currency,
  (currency = {}) => currency
);
const getCollectionsData = createSelector(
  (state) => state.paintingCollections.data.paintingCollections,
  (collections = []) => collections
);
const getGroupData = createSelector(
  (state) => state.paintingCollections.data.paintingGroupData,
  (groupData = {}) => groupData
);
const getPageCount = createSelector(
  (state) => state.paintingCollections.data.pageCount,
  (pageCount) => pageCount || 0
);

export default {
  getCollectionsData,
  getCurrencyData,
  getGroupData,
  getHasLoaded,
  getPageCount,
};
